// extracted by mini-css-extract-plugin
module.exports = {"content":"styles--content--agBTJ","customBtn":"styles--customBtn--2MO2x","innerContent":"styles--innerContent--36ZR_"};